/*eslint-disable */

import Registerform from './registration-form';
import {
  bus
} from '@/main';
import covidPopup from '@/components/public/common/covid-19-popup';
import random_img from '@/assets/images/lange_crub.jpg';
import random_img1 from '@/assets/images/random_img/lange_crub_1.jpg';
import random_img2 from '@/assets/images/random_img/lange_crub_2.jpg';
import random_img3 from '@/assets/images/random_img/lange_crub_3.jpg';
import random_img4 from '@/assets/images/random_img/lange_crub_4.jpg';
import random_img5 from '@/assets/images/random_img/lange_crub_5.jpg';

const $ = window.jQuery = require('jquery');


// Multi Color Bg Img Of Section






var randomImgLoaded;
var randomImgSlide;

export default {
  name: 'singup-page',
  components: {
    'covid-popup': covidPopup,
    'sign-up': Registerform
  },
  props: [],
  data() {
    return {
      redirectTo: '',
      identity: '',
      otp: '',
      submitted: false,
      preloader: true,
      loginFailed: false,
      showPasswordScreen: false,
      loginCHeck: true,
      randomImg: '',
      animationImg: '',
      first_slide: true,
      second_slide: false,
      emailMblError: false,
      countryCode: '+91',
      redirectTo: undefined,
      redirectToHash: undefined,
      redirectToHashFull: undefined,
      userCheckValidLogin: false,
      userCheckNotValidLogin: true,
      getDetailsOfLoginUser: '',
      userCheckNotValidLoginSecondScreen: false,
      otpInMobile: false,
      otpInEmail: false,
      verificationType: "",
      verfiyIdentity: '',
      mblLogined: false,
      signUpFormEnabled: true,
      loginBtnDisabled: false,
      accept_terms: '',
      accordian1: true,
      accordian2: false,
      firstTimeVisit: sessionStorage.getItem('firstTimeVisit'),
      isMobile:false,
      countDown: 30,
      resentOtpFlag:false,
      lbilLinkagePopupState:false
    }
  },
  computed: {
  },
  mounted() {
    if (localStorage.getItem('token') != null && localStorage.getItem('LoginedUserID') != null) {
      this.$router.push('/');
    }
    this.animationImg = random_img
    bus.$emit('showHeaderbtn', false);
    this.randomImg = random_img
    this.randomImgSlide()
    this.randomImgLoaded()
    randomImgSlide = setInterval(() => {
      this.randomImgSlide()
    }, 20000);
    randomImgLoaded = setInterval(() => {
      this.randomImgLoaded()
    }, 21500);
  },
  methods: {
    onResize() {
      this.isMobile = window.innerWidth < 769
    },
    randomImgSlide() {
      setTimeout(() => {
        $(".oncology_well_new").addClass("active")
        $(".oncology_wel_popup").removeClass("active")
        setTimeout(() => {
          $(".oncology_well_new").css('z-index', '10')
          $(".oncology_wel_popup").css('z-index', '11')
          $(".oncology_wel_line_crub").addClass("animation_play")
        }, 1505)
      }, 10000)
      setTimeout(() => {
        $(".oncology_well_new").removeClass("active")
        $(".oncology_wel_popup").addClass("active")
        setTimeout(() => {
          $(".oncology_wel_popup").css('z-index', '10')
          $(".oncology_well_new").css('z-index', '11')
          $(".oncology_wel_line_crub").removeClass("animation_play")
        }, 1500)
      }, 20000)
    },
    randomImgLoaded() {
      setTimeout(() => {
        this.randomImg = random_img1
      }, 3500)
      setTimeout(() => {
        this.randomImg = random_img
      }, 5500)
      setTimeout(() => {
        this.randomImg = random_img2
      }, 7500)
      setTimeout(() => {
        this.randomImg = random_img
      }, 9500)
      setTimeout(() => {
        this.randomImg = random_img3
      }, 11500)
      setTimeout(() => {
        this.randomImg = random_img
      }, 13500)
      setTimeout(() => {
        this.randomImg = random_img4
      }, 15500)
      setTimeout(() => {
        this.randomImg = random_img
      }, 17500)
      setTimeout(() => {
        this.randomImg = random_img5
      }, 19500)
      setTimeout(() => {
        this.randomImg = random_img
      }, 21500)
    },
  },
  beforeCreate: function () {
    $('body').addClass('signup_page_wrp')
  },
  beforeRouteLeave: function (to, from, next) {
    $('body').removeClass('signup_page_wrp')
    clearInterval(randomImgSlide);
    clearInterval(randomImgLoaded);
    next();
  },
  created () {
    window.addEventListener('resize', this.onResize, { passive: true })
    this.onResize()
  },
  beforeDestroy () {
    if (typeof window !== 'undefined') {
      window.removeEventListener('resize', this.onResize, { passive: true })
    }
  },
}
